module.exports = __webpack_public_path__ + "static/media/1.4.f39e07cb.png";